var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"placement":"top"}},[_c('template',{slot:"title"},[_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)]),_c('a-icon',{staticClass:"tooltip-icon",style:(_vm.defaultStyle),attrs:{"type":"exclamation-circle"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }